import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Accordion from "@/components/core/Accordion/Accordion"
import PreviewCartTile from "@/components/PreviewCart/v1/PreviewCartTile"
import { sanitizeTextForAnalytics } from "@/utils/helper"
import { setShowShippingDetails } from "@/store/features/cartSlice"
import { selectCartState } from "@/store/features/cartSlice"
import CartServiceIcon from "@/public/icons/install-service-cart-icon.svg"
import {
  hideCartExpandedView,
  selectGenericState,
} from "@/store/features/genericSlice"
import { INSTALL_SERVICES } from "@/utils/constants"

const ShippingInfo = props => {
  const { i18n, cartItems = [], shippingItems } = props
  const dispatch = useDispatch()
  const { showShippingDetailsForReview } = useSelector(selectCartState)
  const { showCartExpandedView } = useSelector(selectGenericState)
  const [shipItems, setShipItems] = useState([])
  const [shipItemCount, setShipItemCount] = useState(0)

  const [accordionStatus, setAccordionStatus] = useState({
    Parcel: false,
    LTL: false,
    Services: false,
  })

  useEffect(() => {
    const parcelItems = []
    let shipCount = 0
    shippingItems.map((item, i) => {
      if (item.parentLineItemId) {
        const comboChild =
          cartItems.find(prod => prod.id === item.lineItemId) || {}
        if (parcelItems.find(prod => prod.id === item.parentLineItemId)) {
          const comboParent =
            parcelItems.find(prod => prod.id === item.parentLineItemId) || {}
          comboParent.childItems?.push(comboChild)
        } else {
          const comboParent = {
            ...(cartItems.find(prod => prod.id === item.parentLineItemId) ||
              {}),
          }
          comboParent.childItems = [comboChild]
          parcelItems.push(comboParent)
        }
      } else {
        const cartItem =
          cartItems.find(prod => prod.id === item.lineItemId) || {}
        shipCount = shipCount + cartItem?.quantity
        parcelItems.push(cartItem)
      }
    })
    setShipItemCount(shipCount)
    setShipItems(parcelItems)
  }, [shippingItems, cartItems])

  const getEventInfo = (type, needsProductInfo = false, productName = "") => {
    const status = accordionStatus[type] ? "collapse" : "expand"
    if (type === "Parcel") {
      type = "parcel shipping"
    } else if (type === "LTL") {
      type = "freight shipping"
    } else if (type === "Services") {
      type = "e-delivery"
    }
    return JSON.stringify({
      eventAction: `checkout:order summary:${type} ${
        needsProductInfo ? "product" : status
      }`,
      eventName: `checkout:order summary:${type} ${
        needsProductInfo ? "product" : status
      }`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: needsProductInfo
        ? sanitizeTextForAnalytics(productName)
        : status,
      internalLinkPosition: "checkout",
      internalLinkType: "checkout:" + type,
      internalLinkZoneName: "checkout:order summary",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    })
  }

  const updateStatus = (type, status) => {
    setAccordionStatus({
      ...accordionStatus,
      [type]: status,
    })
    dispatch(hideCartExpandedView())
    dispatch(
      setShowShippingDetails({
        ...showShippingDetailsForReview,
        [type]: status,
      })
    )
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="shipping-accordion">
          <div className="shipping-accordion__separator" />
          {shippingItems && (
            <Accordion
              isOpen={showCartExpandedView}
              title={i18n.inYourCart(shipItems ? shipItemCount : "  ")}
              analyticTitleData={getEventInfo("Parcel")}
              handleOpen={() => updateStatus("Parcel", true)}
              handleClose={() => updateStatus("Parcel", false)}
            >
              {shipItems.map((item, i) => {
                const cartItem = cartItems?.find?.(
                  cartitem => cartitem.sku === item.sku
                )
                const hasInstallService =
                  cartItem?.custom?.fields.hasOwnProperty("associatedService")
                const installServiceName =
                  hasInstallService &&
                  cartItem?.custom?.fields?.associatedService
                const installServiceData = shipItems?.find(
                  item => item.sku === installServiceName
                )
                if (installServiceData) {
                  installServiceData.quantity =
                    cartItem?.custom?.fields?.associatedServiceQty
                  installServiceData.image = CartServiceIcon?.src
                }
                if (item?.id && item.category !== INSTALL_SERVICES) {
                  return (
                    <React.Fragment key={i}>
                      <PreviewCartTile
                        i18n={i18n}
                        checkoutMode={true}
                        currencySign={props.currencySign}
                        data={item}
                        productEventInfo={getEventInfo(
                          "Parcel",
                          true,
                          item.name || item.desc
                        )}
                      />
                      {hasInstallService &&
                        installServiceData &&
                        cartItem?.custom?.fields?.associatedServiceQty > 0 && (
                          <PreviewCartTile
                            i18n={i18n}
                            checkoutMode={true}
                            currencySign={props.currencySign}
                            data={installServiceData}
                            productEventInfo={getEventInfo(
                              "Parcel",
                              true,
                              item.name || item.desc
                            )}
                          />
                        )}
                    </React.Fragment>
                  )
                }
              })}
            </Accordion>
          )}
        </div>
      </div>
    </div>
  )
}

export default ShippingInfo
